import { ref } from 'vue'
import { createDiscreteApi } from 'naive-ui'
import { useRouter } from 'vue-router'

export function useInsufficientCreditModal() {
  const showModal = ref(false)
  const router = useRouter()
  const { message } = createDiscreteApi(['message'])

  const showInsufficientCreditModal = () => {
    showModal.value = true
  }

  const hideInsufficientCreditModal = () => {
    console.log('23')

    showModal.value = false
  }

  const handleRecharge = () => {
    // Navigate to recharge page or show recharge modal
    // You can customize this based on your app's routing
    showModal.value = false
    router.push({ name: 'upgrade-pricing' })

    // Example: Navigate to recharge page
    // router.push({ name: 'Recharge' })

    // Or show recharge modal
    // showRechargeModal()
  }

  return {
    showModal,
    showInsufficientCreditModal,
    hideInsufficientCreditModal,
    handleRecharge,
  }
}
